import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';

import { EmojiTitleSelectionPlaceholder } from '../src/emoji-title/EmojiTitleSelectionPlaceholder.tsx';

export const EmojiTitleSelection = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-srcemoji-titleEmojiTitleSelection" */ '../src/emoji-title/EmojiTitleSelection.tsx'
			)
		).EmojiTitleSelection,
	loading: (props) => <EmojiTitleSelectionPlaceholder {...props} />,
});
